function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "019---Astronaut-Sitting-On-Planet",
  fill: "none"
}, React.createElement("path", {
  id: "Shape",
  d: "m15.6 33.64c-.9921172-.393589-1.7004059-1.2846619-1.86-2.34l-2.35-15.69c-.2240566-1.48989.6916827-2.9148488 2.14-3.33l7-2.28-.53 25.11c-1.5251028-.2937126-3.0046186-.7880054-4.4-1.47z",
  fill: "#2c3e50"
}), React.createElement("path", {
  id: "Shape",
  d: "m39 45c.0029438.9794999-.107797 1.9560322-.33 2.91-8.3840108 1.4549678-16.9559892 1.4549678-25.34 0-.9113989-3.9753519.0956628-8.1479934 2.72-11.27 7.72-9.22 22.95-3.81 22.95 8.36z",
  fill: "#f29c1f"
}), React.createElement("path", {
  id: "Shape",
  d: "m38.85 43.05c-.4352957 1.4878149-1.7998144 2.5101856-3.35 2.51-1.9239703-.0216197-3.4783803-1.5760297-3.5-3.5v1.94c.0229769 1.6799759-1.1317218 3.1473186-2.77 3.52-1.0400276.2257642-2.1262318-.0353567-2.9500022-.7091736-.8237703-.6738169-1.2950714-1.6866837-1.2799978-2.7508264v-6.49c.0137136-.4706972-.3028167-.8871845-.76-1-4.79-1.19-5.23-1.16-6.09-2 3.6637883-2.769008 8.5167112-3.3994701 12.7664039-1.6585331 4.2496927 1.7409369 7.2655091 5.5949212 7.9335961 10.1385331z",
  fill: "#e57e25"
}), React.createElement("path", {
  id: "Shape",
  d: "m38.67 47.91c-1.3563866 5.9045963-6.6116139 10.0894846-12.67 10.0894846s-11.3136134-4.1848883-12.67-10.0894846c8.3844377 1.4500028 16.9555623 1.4500028 25.34 0z",
  fill: "#f29c1f"
}), React.createElement("path", {
  id: "Shape",
  d: "m51 45c0 4.52-6.64 7.23-15 8.36-6.6061261.8496459-13.2938739.8496459-19.9 0-8.46-1.13-15.1-3.84-15.1-8.36s6.64-7.23 15.05-8.36c-.9431516 1.1199359-1.6903311 2.3911553-2.21 3.76-10.25 1.89-10.48 5.6-.51 7.51 8.3844377 1.4500028 16.9555623 1.4500028 25.34 0 9.54-1.85 9.89-5.37.33-7.35v-3.42c6.91 1.33 12 3.86 12 7.86z",
  fill: "#f9eab0"
}), React.createElement("path", {
  id: "Shape",
  d: "m39 30.5c0 10.63.13 10.5-.35 11.5-.3939152.8390032-1.107118 1.485542-1.9806298 1.7954978-.8735119.3099558-1.8347224.2575637-2.6693702-.1454978-1.2141187-.5812238-1.9904613-1.8039635-2-3.15v1.9c.0229769 1.6799759-1.1317218 3.1473186-2.77 3.52-1.0331243.2241586-2.1121714-.032052-2.9342528-.6967136-.8220815-.6646616-1.2985817-1.6661275-1.2957472-2.7232864v-6.5c.0137136-.4706972-.3028167-.8871845-.76-1-5.07-1.26-4.64-1.14-4.85-1.22-1.406253-.4890041-2.359678-1.8014594-2.39-3.29v-10.93l15.78-1.12 5.33 9.73c.5743638.6400232.891411 1.4700456.89 2.33z",
  fill: "#35495e"
}), React.createElement("path", {
  id: "Shape",
  d: "m34 31v12.65c-1.2208078-.5736582-2.0001538-1.8011281-2-3.15 0-10.53.13-10-.37-10.81-.174351-.4561019.0061857-.9714257.4270596-1.2189986.420874-.2475729.9590013-.1549927 1.2729404.2189986.4297194.6945333.661403 1.4933229.67 2.31z",
  fill: "#2c3e50"
}), React.createElement("g", {
  fill: "#f0c419"
}, React.createElement("path", {
  id: "Shape",
  d: "m3 26c-.55228475 0-1-.4477153-1-1v-4c0-.5522847.44771525-1 1-1s1 .4477153 1 1v4c0 .5522847-.44771525 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m5 24h-4c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h4c.55228475 0 1 .4477153 1 1s-.44771525 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m50 8c-.5522847 0-1-.44771525-1-1v-4c0-.55228475.4477153-1 1-1s1 .44771525 1 1v4c0 .55228475-.4477153 1-1 1z"
}), React.createElement("path", {
  id: "Shape",
  d: "m52 6h-4c-.5522847 0-1-.44771525-1-1s.4477153-1 1-1h4c.5522847 0 1 .44771525 1 1s-.4477153 1-1 1z"
})), React.createElement("path", {
  id: "Shape",
  d: "m17.44 16.43c-.39.65-.38.93-.67 2.71-.650256 3.8968475 1.3168738 7.762156 4.85 9.53 6.5 3.24 6.45 3.33 7.38 3.33 1.0838202-.0009025 2.0828854-.5863207 2.6134532-1.5313947.5305679-.945074.5101339-2.1028425-.0534532-3.0286053-.6-1-1.35-1.18-3.83-2.43l-3.42-1.71c-.8568552-.426616-1.4586988-1.2365044-1.62-2.18z",
  fill: "#3f5c6c"
}), React.createElement("path", {
  id: "Shape",
  d: "m31 21.25c2.38 5.25.28 6 1.24 8.07 1.25 2.74 7.52 3 5.73-6.2-.33-1.73-.93-4.19-2.32-5.38z",
  fill: "#3f5c6c"
}), React.createElement("path", {
  id: "Shape",
  d: "m46 35c-.5522847 0-1-.4477153-1-1v-4c0-.5522847.4477153-1 1-1s1 .4477153 1 1v4c0 .5522847-.4477153 1-1 1z",
  fill: "#f0c419"
}), React.createElement("path", {
  id: "Shape",
  d: "m48 33h-4c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1z",
  fill: "#f0c419"
}), React.createElement("path", {
  id: "Shape",
  d: "m16 11c0 6.0751322 4.9248678 11 11 11s11-4.9248678 11-11c0-6.07513225-4.9248678-11-11-11s-11 4.92486775-11 11z",
  fill: "#547580"
}), React.createElement("path", {
  id: "Shape",
  d: "m36.61 16.35c-4.12 2.57-10.33 2.07-13.61-1.05-4.84-4.57-.42-11.3 7.5-11.3 2.1507016-.03067647 4.2671057.54085657 6.11 1.65 1.8515714 3.3263641 1.8515714 7.3736359 0 10.7z",
  fill: "#f0c419"
}), React.createElement("path", {
  id: "Shape",
  d: "m35 12c-.5522847 0-1-.4477153-1-1 0-3-3.84-3-4-3-.5522847 0-1-.44771525-1-1s.4477153-1 1-1c2.08 0 6 1 6 5 0 .5522847-.4477153 1-1 1z",
  fill: "#f9eab0"
}), React.createElement("path", {
  id: "Shape",
  d: "m37.59 14c-.2394982.8263902-.5751258 1.6218276-1 2.37-2.9435108 1.7070683-6.4633747 2.1162706-9.72 1.13-5.09-1.54-7.26-5.9-5-9.42 3.18 3.71 8.28 7.23 15.72 5.92z",
  fill: "#f29c1f"
}));

var SvgAstronautSit = function SvgAstronautSit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 53 58",
    width: 512,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAstronautSit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/astronautSit.a374e57b.svg";
export { ForwardRef as ReactComponent };